import React, { Component } from 'react';
import _, { isEmpty, get } from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';

import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import routes from '../../../../routes';
import BinarySelect from '../../../../components/BinarySelect'

import Input from '../../../../components/FormElements/Input';
import Textarea from '../../../../components/FormElements/Textarea';
import Select from '../../../../components/FormElements/Select';
import Datepicker from '../../../../components/FormElements/Datepicker';
import ModalConfirmation from '../../../../components/ModalConfirmation';
// import MultiSelect from '../../../components/FormElements/MultiSelect';
import TimePicker from '../../../../components/FormElements/TimePicker';
import { handleFieldError, initializeForm, handleError } from '../../../../utils/form-validation';
import { formFields, confirmationMessage, successfullyMessage, platformtype, dvPlatform, IONplatform } from './constant';
// import { bidderReport } from '../Io/constant';
import { addIoReportAction, getIoAdvertisersReportAction, getIoEditIdReportAction, createAdvertiserAction, updateAdvertiserAction, listAdvertiserAction, getEditListAdvertiserAction } from '../../../../actions';
import { sortArray } from '../../../../selectors';
import CheckboxGroup from '../../../../components/FormElements/CheckboxGroup';
import RadioGroup from '../../../../components/FormElements/RadioGroup'
import { log } from 'async';
import "../io.scss"
// import BinarySelect from '../../../components/BinarySelect'


const Card = asyncRoute(() => import('../../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));

class EditAdvertiser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: {},
            touched: {},
            errors: {},
            editMode: false,
            submited: false,
            confirmationOpen: false,
            confirmationInfo: '',
            googleAds: [{ masterAccountID: "", goggleAdvertiserID: "", currency: "" }],
            facebookAds: [{ fbAccountID: "", fbCurrency: "" }],
            dv360Ads: [{ dv360AccountID: "", dv360Currency: "" }],
            ionAds: [{ ionAccountID: "", ionCurrency: "" }],
            platformCheck: [],
            platforms: [],
            googleCheck: [],
            facebookCheck: [],
            dv360Check: [],
            ionDataCheck: [],
            advertiserCreate: {
                advertisersPlatforms: []
            },
            editAdvertiserDetails: {},
            initialPlatformType: [],
            // editAdvertiser: {
                ionApiData: {},
                facebookApiData: {},
                googleApiData: {},
                dvApiData: {},
            // },
            addBtn: {
                facebook: false
            },
            removeBtn: {
                facebook: false
            },
            googleNewData: [],
            facebookNewData: [],
            dv360NewData: [],
            ionNewData: [],
            ion: [],
            dvChecked: null,
            ionChecked: null,
            dvLength: null,
            ionLength: null
        };
    }

    async componentWillMount() {
        const { tenantId, authToken, userId, getIoAdvertisersReportAction, configurationList, match } = this.props;
        const currency = get(configurationList.find(currency => currency.attrName === 'CURRENCY'), 'attributeValues', []);
        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
        if (isEmpty(isAuthenticated)) {
            const { history } = this.props;
            history.push(routes.preSignIn);
        }
        const { form, errors } = initializeForm(formFields);
        let curreValue = currency.find(a => a.value == "USD");
        if (curreValue) {
            form.currency = curreValue.key;
        }
        form.startDate = moment().toDate();
        this.setState({ form, errors });
        // this.editId();
        getIoAdvertisersReportAction(tenantId, authToken, userId);

        await this.editAdvertiserData();
        if (this.state.editAdvertiserDetails != undefined) {
            this.state.editAdvertiserDetails.platforms.forEach((b) => {
                platformtype.forEach((a) => {
                    if (b.accountList.length > 0 && b.platform === a.value && a.checked === false) {
                        a.checked = true;
                    }
                })
            })
            console.log("platformtype", platformtype);
        }

        let platform = platformtype.filter((e) => {
            return e.checked === true;
        });
        this.setState({ platformCheck: platform })

        // ============ google edit list data =============
        const googleEdit = this.state.googleApiData.accountList;
        var googleArr = [];
        console.log("google edit", googleEdit);
        if (googleEdit.length > 0) {
            googleEdit.forEach(item => {
                let obj = {
                    masterAccountId: item.masterAccountId,
                    accountId: item.accountId,
                    currency: item.currency,
                    inex: 1
                }
                googleArr.push(obj)
            })
            this.setState({ googleNewData: googleArr })
        }

        // =============== facebook edit list data =============
        const facebookEdit = this.state.facebookApiData.accountList;
        var facebookArr = [];
        if (facebookEdit.length > 0) {
            facebookEdit.forEach(item => {
                let obj = {
                    accountId: item.accountId,
                    currency: item.currency,
                    inex: 1
                }
                facebookArr.push(obj)
            })
            this.setState({ facebookNewData: facebookArr })
        }

        // =============== dv 360 edit list data =============
        const dvEdit = this.state.dvApiData.accountList;
        var dvArr = [];

        if (dvEdit.length > 0) {
            dvEdit.forEach(item => {
                let obj = {
                    accountId: item.accountId,
                    currency: item.currency,
                    inex: 1
                }
                dvArr.push(obj)
            })
            this.setState({ dv360NewData: dvArr })
        }

        // =========== ion edit list data ==============
        const ionEdit = this.state.ionApiData.accountList;
        var ionArr = [];

        if (ionEdit.length > 0) {
            ionEdit.forEach(item => {
                let obj = {
                    accountId: item.accountId,
                    currency: item.currency,
                    inex: 1
                }
                ionArr.push(obj)
            })
            this.setState({ ionNewData: ionArr })
        }

        this.dataLength();
    }

    // ========== google ads start =============

    handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...this.state.googleNewData];
        list[index][name] = value;
        this.setState({ googleNewData: list });
    };

    handleRemoveClick = index => {
        const list = [...this.state.googleNewData];
        list.splice(index, 1);
        this.setState({ googleNewData: list });
    };

    handleAddClick = () => {
        this.setState({ googleNewData: [...this.state.googleNewData, { masterAccountId: '', accountId: '', currency: '', inex: 1 }] });
    };

    renderGoogleValue = () => {
        const { confirmationOpen, confirmationInfo, submited, errors, touched, form, editMode } = this.state;
        let googleAdsValue = this.state.googleNewData.map((googleList, index) => {
            return (
                <div className='ml-5' key={index}>
                    <h5>Google Account {index + 1} :</h5>

                    <div className='ml-5'>
                        <Input
                            onChange={(e) => this.handleInputChange(e, index)}
                            onBlur={this.handleTouch}
                            value={googleList.masterAccountId}
                            setting={formFields[formFields.masterAccountId.key]}
                            error={googleList.masterAccountId === "" ? errors[formFields.masterAccountId.key] : ""}
                            submited={submited}
                            touched={touched[formFields.masterAccountId.key]}
                        />
                    </div>
                    <div className='ml-5'>
                        <Input
                            onChange={(e) => this.handleInputChange(e, index)}
                            onBlur={this.handleTouch}
                            value={googleList.accountId}
                            setting={formFields[formFields.accountId.key]}
                            error={googleList.accountId === "" ? errors[formFields.accountId.key] : ""}
                            submited={submited}
                            touched={touched[formFields.accountId.key]}
                        />
                    </div>
                    <div className='ml-5 removeML'>
                        <Input
                            onChange={(e) => this.handleInputChange(e, index)}
                            onBlur={this.handleTouch}
                            value={googleList.currency}
                            setting={formFields[formFields.currency.key]}
                            error={googleList.currency === "" ? errors[formFields.currency.key] : ""}
                            submited={submited}
                            touched={touched[formFields.currency.key]}
                        />
                        <button className="btn-remove-io" onClick={() => this.handleRemoveClick(index)}><i className='mdi mdi-delete'></i></button>
                    </div>
                </div>
            )
        })
        return googleAdsValue;
    };

    // =============== google ads end ===============


    // ============ facebook ads start ================
    handleFacebookInputChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...this.state.facebookNewData];
        list[index][name] = value;
        this.setState({ facebookNewData: list });
    };

    handleFacebookRemoveClick = index => {
        const list = [...this.state.facebookNewData];
        list.splice(index, 1);
        this.setState({ facebookNewData: list });
    };

    handleFacebookAddClick = (e) => {
        this.setState({ facebookNewData: [...this.state.facebookNewData, { accountId: "", currency: "", inex: 1 }] });
    };

    renderFacebookValue = () => {
        const { confirmationOpen, confirmationInfo, submited, errors, touched, form, editMode } = this.state;
        let facebookAdsValue = this.state.facebookNewData.map((facebookList, index) => {
            return (
                <div className='ml-5' key={index}>
                    <h5>Facebook Account {index + 1} :</h5>
                    <div className='ml-5'>
                        <Input
                            onChange={(e) => this.handleFacebookInputChange(e, index)}
                            onBlur={this.handleTouch}
                            value={facebookList.accountId}
                            setting={formFields[formFields.accountId.key]}
                            error={facebookList.accountId === "" ? errors[formFields.accountId.key] : ""}
                            submited={submited}
                            touched={touched[formFields.accountId.key]}
                        />
                    </div>
                    <div className='ml-5 removeML'>
                        <Input
                            onChange={(e) => this.handleFacebookInputChange(e, index)}
                            onBlur={this.handleTouch}
                            value={facebookList.currency}
                            setting={formFields[formFields.currency.key]}
                            error={facebookList.currency === "" ? errors[formFields.currency.key] : ""}
                            submited={submited}
                            touched={touched[formFields.currency.key]}
                        />
                        <button className="btn-remove-io" onClick={() => this.handleFacebookRemoveClick(index)}><i className='mdi mdi-delete'></i></button>

                    </div>
                </div>
            )
        })
        return facebookAdsValue;
    };
    // ============= facebook ads end =================

    // ============ DV360 ads start ================
    handleDV360InputChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...this.state.dv360NewData];
        list[index][name] = value;
        this.setState({ dv360NewData: list });
    };

    handleDV360RemoveClick = index => {
        const list = [...this.state.dv360NewData];
        list.splice(index, 1);
        this.setState({ dv360NewData: list });
    };

    handleDV360AddClick = () => {
        this.setState({ dv360NewData: [...this.state.dv360NewData, { accountId: "", currency: "", inex: 1 }] });
    };

    renderDV360Value = () => {
        const { confirmationOpen, confirmationInfo, submited, errors, touched, form, editMode } = this.state;
        let dv360AdsValue = this.state.dv360NewData.map((dv360AdsList, index) => {
            return (
                <div className='ml-5' key={index}>
                    <h5>DV 360 Account {index + 1} :</h5>

                    <div className='ml-5'>
                        <Input
                            onChange={(e) => this.handleDV360InputChange(e, index)}
                            onBlur={this.handleTouch}
                            value={dv360AdsList.accountId}
                            setting={formFields[formFields.accountId.key]}
                            error={dv360AdsList.accountId === "" ? errors[formFields.accountId.key] : ""}
                            submited={submited}
                            touched={touched[formFields.accountId.key]}
                        />
                    </div>
                    <div className='ml-5 removeML'>
                        <Input
                            onChange={(e) => this.handleDV360InputChange(e, index)}
                            onBlur={this.handleTouch}
                            value={dv360AdsList.currency}
                            setting={formFields[formFields.currency.key]}
                            error={dv360AdsList.currency === "" ? errors[formFields.currency.key] : ""}
                            submited={submited}
                            touched={touched[formFields.currency.key]}
                        />
                        <button className="btn-remove-io" onClick={() => this.handleDV360RemoveClick(index)}><i className='mdi mdi-delete'></i></button>
                    </div>
                </div>
            )
        })
        return dv360AdsValue;
    };
    // ============= DV360 ads end =================

    // ============ ION ads start ================
    handleIONInputChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...this.state.ionNewData];
        list[index][name] = value;
        this.setState({ ionNewData: list });
    };

    handleIONRemoveClick = index => {
        const list = [...this.state.ionNewData];
        list.splice(index, 1);
        this.setState({ ionNewData: list });
    };

    handleIONAddClick = () => {
        this.setState({ ionNewData: [...this.state.ionNewData, { accountId: "", currency: "", inex: 1 }] });
    };

    renderIONValue = () => {
        const { confirmationOpen, confirmationInfo, submited, errors, touched, form, editMode } = this.state;
        let ionAdsValue = this.state.ionNewData != undefined && this.state.ionNewData.map((ionAdsList, index) => {
            return (
                <div className='ml-5' key={index}>
                    <h5>ION Account {index + 1} :</h5>

                    <div className='ml-5'>
                        <Input
                            onChange={(e) => this.handleIONInputChange(e, index)}
                            onBlur={this.handleTouch}
                            value={ionAdsList.accountId}
                            setting={formFields[formFields.accountId.key]}
                            error={ionAdsList.accountId === "" ? errors[formFields.accountId.key] : ""}
                            submited={submited}
                            touched={touched[formFields.accountId.key]}
                        />
                    </div>
                    <div className='ml-5 removeML'>
                        <Input
                            onChange={(e) => this.handleIONInputChange(e, index)}
                            onBlur={this.handleTouch}
                            value={ionAdsList.currency}
                            setting={formFields[formFields.currency.key]}
                            error={ionAdsList.currency === "" ? errors[formFields.currency.key] : ""}
                            submited={submited}
                            touched={touched[formFields.currency.key]}
                        />
                        <button className="btn-remove-io" onClick={() => this.handleIONRemoveClick(index)}><i className='mdi mdi-delete'></i></button>
                    </div>
                </div>
            )
        })
        return ionAdsValue;
    };
    // ============= ION ads end =================

    // editId = async () => {
    //     const { match: { params: { id } }, tenantId, authToken, userId, getIoEditIdReportAction } = this.props;
    //     let { form } = this.state;
    //     let currency = '';
    //     if (id) {
    //         const { responseCode: { status }, responseList } = await getIoEditIdReportAction(tenantId, authToken, userId, { list: id });
    //         if (status === "Success") {
    //             let { advertiserId, brief, budget, endDate, name, startDate } = responseList;
    //             let getCurrency = (responseList.currency || []).find(a => a.ti_isactive == 1);
    //             if (getCurrency) {
    //                 currency = getCurrency.currency;
    //             }
    //             startDate = startDate ? new Date(startDate) : null;
    //             endDate = endDate ? new Date(endDate) : null;
    //             // endDate = endDate ? moment(new Date(endDate)).isSame(moment('Dec 31, 2050')) ? '' : new Date(endDate) : null;
    //             form = { advertiserId, brief, budget, currency, endDate, name, startDate };
    //             this.setState({ form });
    //         }
    //     }
    // };

    handleChange = (e) => {
        let { form, platformCheck } = this.state;
        let { value, name } = e.target;
        form[name] = value;

        this.setState({ form });
        if (form.platform != "") {
            let platform = form.platform.filter((e) => {
                return e.checked === true;
            });

            this.setState({ platformCheck: platform });
        }

        if (typeof +value === "number" && !Array.isArray(value)) {
            if (name === "recActiveDV360") {
                console.log("dv", value);
                this.setState({ dvChecked: value });
            }
            if (name === "recActiveION") {
                console.log("ion", value);
                this.setState({ ionChecked: value });
            }
        }

        platformtype.map(check => {
            console.log("platform", check);
            if (check.value === "Facebook" && check.checked === false) {
                const list = this.state.facebookNewData;
                list.splice(0, this.state.facebookNewData.length);
                this.setState({ facebookNewData: list });
            } 
            else if (check.value === "Google Adwords" && check.checked === false) {
                const list = this.state.googleNewData;
                list.splice(0, this.state.googleNewData.length);
                this.setState({ googleNewData: list });
            } else if (check.value === "DV 360" && check.checked === false) {
                const list = this.state.dv360NewData;
                list.splice(0, this.state.dv360NewData.length);
                this.setState({ dv360NewData: list });
            } else if (check.value === "ION" && check.checked === false) {
                const list = this.state.ionNewData;
                list.splice(0, this.state.ionNewData.length);
                this.setState({ ionNewData: list });
            }
        })
    };

    handleTouch = (e) => {
        let { touched, form, errors } = this.state;
        let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
        errors[e.target.name] = error;
        touched[e.target.name] = true;
        this.setState({ touched, errors });
    };

    toggleModal = (confirmation) => {
        const { confirmationOpen } = this.state;
        this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
    };

    confirmationCallBack = (success, info) => {
        const { confirmationOpen } = this.state;
        if (success && info.action.type === 'Confirmation') {
            this.submitForm();
        } else if (info.action.type === 'alert') {
            this.setState({ confirmationOpen: !confirmationOpen }, () => {
                const { history } = this.props;
                history.push('/' + routes.mainRoute + '/' + routes.containers.admin + '/' +routes.admin.advertiser.name);
            });
            return;
        }

        this.setState({ confirmationOpen: false });
    };

    async submitForm() {
        const { match: { params: { id } }, addIoReportAction, tenantId, authToken, userId } = this.props;
        const { form } = this.state;
        const { advertiserId, brief, startDate, endDate, name, budget } = form;
        let addParams = { addup: 'auto' };
        let data = {
            advertiserId,
            brief,
            startDate: moment(startDate).format('MMM DD, YYYY'),
            endDate: endDate ? moment(endDate).format('MMM DD, YYYY') : null,
            // endDate: endDate === '' ? moment('Dec 31, 2050', 'MMM DD, YYYY').format('MMM DD, YYYY') : moment(endDate).format('MMM DD, YYYY'),
            name: name.replace(/^\s+|\s+$/gm, ''),
            budget,
            rec_active: 1,
            currency: [{ currency: form.currency, ti_isactive: 1 }],
            geo: [],
        };
        if (id) {
            addParams = { addup: id };
        }
        // console.log(data)
        // return false
        const { desc = '', status = '' } = await (addIoReportAction(tenantId, authToken, userId, data, addParams) || '');

        if (status === 'Success') {
            this.setState({ confirmationOpen: false }, () => {
                this.toggleModal(successfullyMessage);
            });
            return;
        } else {
            const info = { action: { confirmationMessage: desc, type: 'error' } };
            this.toggleModal(info);
        }
    }

    reset = () => {
        return {
            advertiserId: '',
            brief: '',
            startDate: '',
            endDate: '',
            name: '',
            budget: '',
            currency: '',
        };
    };


    // ======== create advertiser =========
    handleSubmit = async (e) => {
        e.preventDefault();

        // // google data
        // await this.ionCheck()
        // await this.dvCheck();
        // await this.facebookCheck();
        // await this.googleNewCheck();
        // await this.createAdvertiser();
    };

    //  ================= edit advertiser details =============
    editAdvertiserData = async () => {
        const { match, path } = this.props;
        const advertiserId = match.params.id;

        const { tenantId, authToken, userId, payload, getEditListAdvertiserAction, preSignInData } =
            this.props;
            console.log("advertiser id", advertiserId);
        // const {responseList} = preSignInData;
        
        const {
            responseCode: { status = "" },
            response,
        } = await getEditListAdvertiserAction({
            tenantId,
            authToken,
            userId,
            payload,
            advertiserId
        });

        if (status === "Success") {
            this.setState({ editAdvertiserDetails: response.advertisersPlatforms[0] });

            const platformEdit = response.advertisersPlatforms.length > 0 && response.advertisersPlatforms[0].platforms;

            if (platformEdit.length > 0) {
                platformEdit.map(edit => {
                    if (edit.platform === 'Facebook') {
                        this.setState({ facebookApiData: edit })
                    } 
                    if (edit.platform === 'ION') {
                        this.setState({ ionApiData: edit })
                    } 
                    if (edit.platform === 'Google Adwords') {
                        this.setState({ googleApiData: edit })
                    } 
                    if (edit.platform === 'DV 360') {
                        this.setState({ dvApiData: edit })
                    }
                })
            }

        } else {
            console.log("something went wrong");
        }
    }


    // =================== update advertiser ===============
    updateAdvertiser = async () => {
        const payload = {
            advertisersPlatforms: []
        }

        const paramsObj = {
            advertiser: this.state.editAdvertiserDetails.advertiser,
            inex: 1,
            platforms: [
                {
                    platform: "ION",
                    accountList: this.state.ionNewData
                },
                {
                    platform: "Facebook",
                    accountList: this.state.facebookNewData
                },
                {
                    platform: "Google Adwords",
                    accountList: this.state.googleNewData
                },
                {
                    platform: "DV 360",
                    accountList: this.state.dv360NewData
                },
            ]
        };

        payload.advertisersPlatforms.push(paramsObj);


        const { tenantId, authToken, userId, updateAdvertiserAction, history, match } =
            this.props;
        const {
            responseCode: { status = "", msg="" },
            // responseList,
        } = await updateAdvertiserAction({
            tenantId,
            authToken,
            userId,
            payload,
        });

        const successfullyMessage = {
            action: {
              confirmationMessage: msg,
              type: 'alert',
            }
          }

        if (status === "Success") {
            this.setState({ confirmationOpen: false }, () => {
                this.toggleModal(successfullyMessage);
              });
            // history.push(`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.advertiser.name}`);
        } else {
            console.log("somthing went wrong");
        }

    }

    dataLength = () => {
        const { ionApiData, dvApiData } = this.state;
        const dvDataLength = dvApiData.accountList != undefined ? dvApiData.accountList.length : "";
        const ionDataLength = ionApiData.accountList != undefined ? ionApiData.accountList.length : ""; 
        this.setState({dvLength: dvDataLength})
        this.setState({ionLength: ionDataLength})
    }

    render() {
        const { confirmationOpen, confirmationInfo, submited, errors, touched, form, editMode, dvChecked, ionChecked, ionApiData, dvApiData, dvLength, ionLength, editAdvertiserDetails } = this.state;

        const { ioAdvertisersReport, configurationList, match: { params: { id } } } = this.props;
        const currency = get(configurationList.find(currency => currency.attrName === 'CURRENCY'), 'attributeValues', []);
        let getCurrency = currency.find(a => a.key == form.currency);
        let currrncyName = '';
        if (getCurrency) {
            currrncyName = getCurrency.value;
        }

        let editAdvertiser = '';
        if (id && editAdvertiserDetails != undefined) {
            editAdvertiser = editAdvertiserDetails;
        }



        return (
            <>
                {confirmationOpen && (<ModalConfirmation
                    open={confirmationOpen}
                    onClose={this.toggleModal}
                    confirmationInfo={confirmationInfo}
                    handelConfirmationMessage={this.confirmationCallBack}
                />)}
                <div className="main-panel ion">
                    <div className="content-wrapper">
                        <BreadCrumb />
                        <div className="row justify-content-center">
                            <div className="col-md-10 grid-margin">
                                <Card>
                                    {
                                        id ? <div class="form-group row">
                                            
                                            <label for="advertiserId" class="col-sm-3 col-form-label">Advertiser </label>
                                            <div class="col-md-12">
                                                <input value={editAdvertiserDetails != undefined ? editAdvertiserDetails.advertiser : ''} disabled={id ? true : false} className="input-disabled" />
                                            </div>
                                        </div> : <Select
                                            onChange={this.handleChange}
                                            onBlur={this.handleTouch}
                                            value={form[formFields.advertiserId.key]}
                                            setting={formFields[formFields.advertiserId.key]}
                                            error={errors[formFields.advertiserId.key]}
                                            submited={submited}
                                            touched={touched[formFields.advertiserId.key]}
                                            options={sortArray(ioAdvertisersReport)}
                                            disabled={id ? true : false}
                                        />
                                    }

                                    <CheckboxGroup
                                        onChange={this.handleChange}
                                        onBlur={this.handleTouch}
                                        value={form[formFields.platform.key]}
                                        setting={formFields[formFields.platform.key]}
                                        error={errors[formFields.platform.key]}
                                        submited={submited}
                                        allowClear={true}
                                        touched={touched[formFields.platform.key]}
                                        options={id ? platformtype : this.state.initialPlatformType}
                                        editAdvertiser={editAdvertiser}
                                        advertiserId={id}
                                    />
                                    {this.state.platformCheck != '' &&
                                        this.state.platformCheck.map((e, index) => {
                                            return (
                                                <>
                                                    {
                                                        e.value == "Google Adwords" ? <div className='mt-5' key={index}>
                                                            <h5 className='text-primary ml-5'>Google Ads</h5>
                                                            <ul className='ml-5'>
                                                                <li>
                                                                    Please provide admin access to the following email Id: ads@torcai.com
                                                                </li>
                                                                <li>
                                                                    Please fill your Google ads account id below
                                                                </li>
                                                            </ul>
                                                            <this.renderGoogleValue />
                                                            <button className='btn-add-io' onClick={() => this.handleAddClick()}><i className="mdi mdi-plus-box"></i> Add Google Platform</button>
                                                        </div> : ""
                                                    }
                                                    {/* ***********************Facebook ACCounts code */}
                                                    {
                                                        e.value == "Facebook" ? <div className='mt-5'>
                                                            <h5 className='text-primary ml-5'>Facebook Ads</h5>
                                                            <ul className='ml-5'>
                                                                <li>
                                                                    Please provide admin access to the following email Id: ads@torcai.com
                                                                </li>
                                                                <li>
                                                                    Please fill your Facebook ads account id below
                                                                </li>
                                                            </ul>
                                                            <this.renderFacebookValue />
                                                            <button className='btn-add-io' onClick={(e) => this.handleFacebookAddClick(e)}><i className="mdi mdi-plus-box"></i> Add Facebook Platform</button>
                                                        </div> : ""
                                                    }
                                                    {/* ******************DV360 Ads Accounts Data */}
                                                    {
                                                        e.value == "DV 360" ? <div className='mt-5'>
                                                            <h5 className='text-primary ml-5'>DV360 Account</h5>
                                                            <h6 className='ml-5'>Do You Want To Link Your DV360 Account Or Use Infomo Account To Advertise</h6>

                                                            <div className='ml-5 mt-5'>
                                                                <BinarySelect
                                                                    onChange={this.handleChange}
                                                                    onBlur={this.handleTouch}
                                                                    value={form[formFields.recActiveDV360.key]}
                                                                    setting={formFields[formFields.recActiveDV360.key]}
                                                                    error={errors[formFields.recActiveDV360.key]}
                                                                    submited={submited}
                                                                    touched={touched[formFields.recActiveDV360.key]}
                                                                    options={sortArray((formFields[formFields.recActiveDV360.key]).options)}
                                                                    dvLength={dvLength}
                                                                />
                                                            </div>

                                                            {
                                                                dvChecked == 1 &&
                                                                <>
                                                                    <ul className='ml-5'>
                                                                        <li>
                                                                            Please provide admin access to the following email Id: ads@torcai.com
                                                                        </li>
                                                                        <li>
                                                                            Please fill your DV360 account id below
                                                                        </li>
                                                                    </ul>
                                                                    <this.renderDV360Value />
                                                                    <button className='btn-add-io' onClick={() => this.handleDV360AddClick()}><i className="mdi mdi-plus-box"></i> Add DV360 Platform</button>
                                                                </>
                                                            }

                                                        </div> : ""
                                                    }
                                                    {/* ****************** ION Accounts Data */}
                                                    {
                                                        e.value == "ION" ? <div className='mt-5'>
                                                            <h5 className='text-primary ml-5'>ION Account</h5>
                                                            <h6 className='ml-5'>Do You Want To Link Your ION Account Or Use Infomo Account To Advertise</h6>

                                                            <div className='ml-5 mt-5'>
                                                                <BinarySelect
                                                                    onChange={this.handleChange}
                                                                    onBlur={this.handleTouch}
                                                                    value={form[formFields.recActiveION.key]}
                                                                    setting={formFields[formFields.recActiveION.key]}
                                                                    error={errors[formFields.recActiveION.key]}
                                                                    submited={submited}
                                                                    touched={touched[formFields.recActiveION.key]}
                                                                    options={sortArray((formFields[formFields.recActiveION.key]).options)}
                                                                    ionLength={ionLength}
                                                                />
                                                            </div>
                                                            {
                                                                ionChecked == 1 &&
                                                                <>
                                                                    <ul className='ml-5'>
                                                                        <li>
                                                                            Please provide admin access to the following email Id: ads@torcai.com
                                                                        </li>
                                                                        <li>
                                                                            Please fill your ION account id below
                                                                        </li>
                                                                    </ul>
                                                                    <this.renderIONValue />
                                                                    <button className='btn-add-io' onClick={() => this.handleIONAddClick()}><i className="mdi mdi-plus-box"></i> Add ION Platform</button>
                                                                </>
                                                            }
                                                        </div> : ""
                                                    }
                                                </>
                                            )
                                        })
                                    }
                                    <div className="form-group row">
                                        <div className="col-sm-12">
                                            <center>
                                                <button type="submit" onClick={() => this.updateAdvertiser()} className="btn btn-primary">Save</button>
                                                {' '}
                                                {/* <button type="button" onClick={() => { this.setState({ form: this.reset() }); }} className="btn btn-secondary">Reset</button> */}
                                                {' '}
                                                <Link to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.advertiser.name}`}><button type="button" className="btn btn-secondary">Cancel</button></Link>
                                            </center>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default connect(
    state => ({
        configurationList: get(state, 'app.configurationData.responseList', []),
        ioAdvertisersReport: get(state, 'app.ioAdvertisersReport.responseList', []),
        tenantId: get(state, 'app.preSignInState.tenantId', ''),
        userId: get(state, 'app.preSignInData.userId', ''),
        authToken: get(state, 'app.signInData.authToken', ''),
        preSignInData: get(state, 'app.preSignInData', [])
    }),
    {
        addIoReportAction,
        getIoAdvertisersReportAction,
        getIoEditIdReportAction,
        createAdvertiserAction,
        listAdvertiserAction,
        updateAdvertiserAction,
        getEditListAdvertiserAction
    }
)(EditAdvertiser);

// ----*  IO propTypes * ----
EditAdvertiser.propTypes = {
    addIoReportAction: PropTypes.func,
    getIoAdvertisersReportAction: PropTypes.func,
    configurationList: PropTypes.array,
    ioAdvertisersReport: PropTypes.array,
};